import { useRef, useState } from "react";
import { FormContent } from "@/react/components/FormRenderer/FormContent";
import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";
import type { ElementType } from "@/react/types/Element";
import type { Form } from "@/react/types/Form";
import { Modal } from "@circle-react-uikit/ModalV2";
import { MODAL_SIZES } from "@circle-react-uikit/ModalV2/ModalContent";
import { ModalHeader } from "./ModalHeader";

interface FormModalComponentProps {
  form: Form;
  formElements: ElementType[];
  handleModalClose: () => void;
  index: number;
  isPreview: boolean;
}
export const FormModalComponent = ({
  form,
  index,
  formElements,
  isPreview,
  handleModalClose,
}: FormModalComponentProps) => {
  const [shouldHideTitle, setShouldHideTitle] = useState(false);
  const initialFocusRef = useRef(null);
  const modal = useModal();
  if (!modal || !modal.visible) return null;

  const handleClose = () => {
    handleModalClose();
    void modal.hide();
    // eslint-disable-next-line sonarjs/post-message -- Disabled for plugin version update. Fix when possible.
    window.parent.postMessage(
      { type: "resize", formUid: form.uid, formIndex: index, height: "0" },
      "*",
    );
  };
  return (
    <Modal
      isOpen={modal.visible}
      contentPortalId="form-modal-portal"
      initialFocus={initialFocusRef}
    >
      <Modal.Overlay onClick={handleClose} />
      <Modal.Content
        size={MODAL_SIZES.md}
        style={{ backgroundColor: form.background_color }}
        id={`form-modal-${form.uid}`}
      >
        <style>
          {`#form-modal-${form.uid} label > span,
           #form-modal-${form.uid} h4,
           #form-modal-${form.uid} h5 {
             color: ${form.text_color};
           }
           #form-modal-${form.uid} #form-modal-close-button:hover {
             background-color: ${form.background_color};
           }
           #form-modal-${form.uid} #form-modal-close-button svg {
             color: ${form.text_color} !important;
           }`}
        </style>
        <ModalHeader
          form={form}
          handleClose={handleClose}
          shouldHideTitle={shouldHideTitle}
        />
        <Modal.Body className="px-8 !pt-0">
          <FormContent
            form={form}
            index={index}
            formElements={formElements}
            isPreview={isPreview}
            isModal
            textColor={form.text_color}
            backgroundColor={form.background_color}
            initialFocusRef={initialFocusRef}
            setShouldHideTitle={setShouldHideTitle}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

const FormModal = ModalManager.create((props: FormModalComponentProps) => (
  <FormModalComponent {...props} />
));
export const useFormModal = () => useModal(FormModal);
